<template>
  <div class="base-logo">
    <svg viewBox="0 0 440 301" xmlns="http://www.w3.org/2000/svg">
      <g ref="logo">
        <g ref="betterplace">
          <path
            fill="#FFF"
            fill-rule="nonzero"
            d="M8.5 8.5v80h249v-80z"
            style="fill: #fff"
          />
          <path
            d="M0 0h266v97H0V0zm8.5 8.5v80h249v-80H8.5z"
            fill="#000"
            fill-rule="nonzero"
          />
          <path
            d="M222.128 43.753c3.081 0 4.306 2.348 4.47 5.186h-9.366c.246-3.013 1.814-5.186 4.896-5.186zm-35.175 12.871c-.917 1.224-2.314 2.01-4.105 2.01-2.096 0-3.711-.83-3.711-2.752 0-3.282 3.808-3.278 6.429-3.278h2.533c-.077 1.846-.452 3.088-1.146 4.02zm-34.53 1.747c-3.887 0-5.154-4.104-5.154-7.293 0-3.144 1.486-7.16 5.241-7.16 3.8 0 4.848 4.148 4.848 7.16 0 3.1-1.092 7.293-4.935 7.293zm-36.03-14.618c3.08 0 4.312 2.348 4.477 5.186h-9.367c.247-3.013 1.808-5.186 4.89-5.186zM48.048 58.37c-3.886 0-5.152-4.104-5.152-7.293 0-3.144 1.485-7.16 5.24-7.16 3.8 0 4.848 4.148 4.848 7.16 0 3.1-1.092 7.293-4.936 7.293zM70.8 43.655c3.08 0 4.314 2.445 4.477 5.283H65.91c.246-3.012 1.807-5.283 4.89-5.283zm100.103-11.932l-5.857 1.878V48.94h-1.684c-.546-5.272-3.23-9.564-9.323-9.564-3.45 0-5.677 1.529-6.986 3.712h-.088v-3.188l-8.816-.004c-3.493 0-4.413 3.017-4.675 5.113h-.087V39.9h-5.196V54.94c-3.495 2.217-6.896 3.776-10.267 3.791-3.625.016-6.157-2.486-6.42-6.111h14.143c0-7.86-2.689-13.125-9.295-13.148-6.988-.022-10.437 5.373-10.437 11.878 0 2.294.418 4.286 1.216 5.946-1.037.578-2.27 1.08-3.489 1.075-2.227-.01-2.751-1.79-2.751-3.711V44.179h3.729l2.569-4.28h-6.298v-8.068l-5.851 1.877v6.185h-6.173v-8.067l-5.85 1.878-.01 6.232h-2.313v4.2h2.323v10.44c-3.643 2.358-7.181 4.043-10.687 4.057-3.624.016-6.157-2.39-6.42-6.014H79.99c0-7.86-2.626-13.222-9.233-13.244-6.138-.02-9.545 4.14-10.283 9.563h-1.486c-.545-5.272-3.232-9.563-9.323-9.563-3.058 0-5.11 1.266-6.725 3.406h-.088V31.724L37 33.56v28.83h5.677v-2.751h.088c1.703 2.401 4.41 3.275 6.9 3.275 6.067 0 8.756-5.01 9.318-10.255h1.454c.736 6.132 4.914 10.255 11.63 10.255 2.975 0 6.508-1.097 11.628-3.752 1.037 2.355 3.234 3.744 6.439 3.747 1.736 0 2.746-.321 3.892-.857l-1.535-4.062c-.299.197-.66.343-1.112.367-2.224.11-2.513-1.78-2.513-3.701V44.174l6.173.005v11.44c0 4.455 2.532 7.294 7.118 7.294 3.425 0 4.616-.826 7.47-2.406 1.974 1.632 4.688 2.503 8.034 2.503 2.757 0 5.992-.94 10.529-3.192v2.571h5.85v-8.254c0-3.231 0-9.17 4.761-9.17 1.02 0 2.037.166 2.574.458V70.09h5.851V59.812h.088c2.052 2.49 4.103 3.1 6.594 3.1 6.435 0 9.095-4.758 9.5-10.286h1.637v2.887c0 4.454 2.532 7.292 7.118 7.292 2.793 0 3.921-.551 4.845-.967 1.301.705 2.843 1.075 4.4 1.075 2.662 0 5.588-1.398 6.942-3.887h.088c.044.7.044 2.184.262 3.363h5.152a99.92 99.92 0 01-.261-5.022c-.033-1.26-.067-3.23-.08-4.771h1.4c.743 5.679 4.4 10.309 10.949 10.317 2.427.003 5.866-1.138 8.675-3.179 2.011 2.129 5.02 3.276 8.862 3.276 3.144 0 5.977-1.138 7.952-2.51v-4.74c-2.647 2.24-4.57 2.971-7.69 2.971-3.625 0-6.158-2.486-6.42-6.111h14.143c0-7.86-2.69-13.125-9.296-13.148-6.987-.022-10.436 5.373-10.436 11.88 0 1.806.26 3.426.762 4.844-1.429 1.14-2.944 2.07-5.46 2.175-4.101.173-6.07-3.188-6.07-7.336 0-4.237 2.314-7.106 5.938-7.119 1.632-.005 2.062.22 3.235.875l1.772-3.645c-2.257-1.129-3.827-1.771-6.185-1.771-6.094 0-9.805 4.335-10.684 9.602h-1.473c-.097-6.394-2.938-9.602-9.675-9.602-2.49 0-5.548.655-7.817 1.703l.174 5.022c1.965-1.485 4.455-2.445 6.943-2.445 3.45 0 5.052 1.685 5.052 5.31h-3.233c-2.445 0-5.312-.244-7.54.847-2.227 1.092-3.843 3.056-3.843 6.42 0 1.003.217 1.902.595 2.693a1.987 1.987 0 01-.494.073c-2.227 0-2.752-2.525-2.752-4.446l.007-22.829z"
            fill="#000"
          />
        </g>
        <g ref="lab">
          <path
            class="base-logo__bg"
            fill-rule="nonzero"
            d="M97.392 92.527v204h164v-204z"
          />
          <path
            d="M266 89H93v212h173V89zm-8.5 8.5v195h-156v-195h156z"
            fill="#000"
            fill-rule="nonzero"
          />
          <path
            d="M168.798 248.203c1.011 0 1.873.827 1.917 1.837l.26 6.042a1.75 1.75 0 01-1.759 1.837H136.13a1.843 1.843 0 01-1.837-1.838V132.94c0-1.01.827-1.838 1.837-1.838h6.04c1.01 0 1.837.827 1.837 1.838v113.427c0 1.01.827 1.837 1.837 1.837h22.954zm11.982-115.27l9.352 123.206a1.682 1.682 0 01-1.7 1.832h-6.124c-1.011 0-1.89-.825-1.952-1.833l-.893-14.414c-.062-1.008-.94-1.833-1.951-1.833h-18.745a1.676 1.676 0 01-1.694-1.832l8.2-105.126c.078-1.007.97-1.832 1.98-1.832h11.55c1.01 0 1.9.825 1.977 1.833zm-4.01 97.159c1.011 0 1.773-.825 1.692-1.832l-5.288-66.504c-.08-1.009-.212-1.009-.292 0l-5.287 66.504a1.674 1.674 0 001.692 1.832h7.484zm42.694-98.567c.451.243 1.393 1.038 2.094 1.765l1.658 1.724c.701.729 1.274 2.151 1.274 3.162v48.917c0 1.01-.192 2.211-.426 2.668-.234.457-.986 1.412-1.67 2.123a1.885 1.885 0 000 2.585c.684.71 1.436 1.666 1.67 2.123.234.457.426 1.657.426 2.668v51.603c0 1.01-.573 2.434-1.274 3.161l-1.658 1.724c-.7.728-1.643 1.524-2.094 1.766-.45.243-1.646.443-2.657.443h-20.061a1.843 1.843 0 01-1.838-1.838v-123.2c0-1.01.827-1.837 1.838-1.837h20.061c1.01 0 2.206.2 2.657.443zm-4.776 114.9v-44.703c0-1.01-.827-1.837-1.837-1.837h-6.313c-1.01 0-1.837.827-1.837 1.837v44.704c0 1.01.827 1.837 1.837 1.837h6.313c1.01 0 1.837-.827 1.837-1.837zm0-58.635v-45.076c0-1.01-.827-1.837-1.837-1.837h-6.313c-1.01 0-1.837.827-1.837 1.837v45.076c0 1.01.827 1.838 1.837 1.838h6.313c1.01 0 1.837-.827 1.837-1.838z"
            fill="#000"
            fill-rule="nonzero"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import animations from "../logoanimations";

export default {
  name: "BaseLogo",

  props: {
    color: {
      type: String,
      default: "#ffffff",
    },
  },

  methods: {
    animate() {
      const animation =
        animations[Math.floor(Math.random() * animations.length)];

      animation(this.$refs);
    },
  },

  mounted() {
    setTimeout(this.animate, 1000);
  },
};
</script>

<style  lang="scss">
.base-logo {
  display: flex;
}

.base-logo__bg {
  fill: var(--category-color);
}

.base-logo svg {
  width: 100%;
  height: 100%;
  color: #000;
  overflow: visible;
}
</style>
